import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BEResponse } from '@qtek/core/api-core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { HTTP_BASE_URL, Tag } from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { HttpEntityManager } from '../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class TagManagerService extends HttpEntityManager<Tag, Tag> {
  protected http = inject(HttpClient);
  private webSocketService = inject(WebSocketService);
  private httpBaseUrl = inject(HTTP_BASE_URL);

  entityName: WebsocketEntTypes = 'Tag';
  wsManager = new WSEntityManager(this.webSocketService, this.entityName);

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  constructor() {
    super();
  }

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...payload }, true);
  }

  createTag(
    tag: Pick<Tag, 'tagName' | 'description' | 'color' | 'icon'>
  ): Observable<BEResponse<Tag>> {
    return this.http.post<BEResponse<Tag>>(
      `${this.httpBaseUrl}/api/v2/model/${this.entityName}`,
      tag,
      { withCredentials: true }
    );
  }

  updateTag(
    tag: Pick<Tag, 'tagName' | 'description' | 'color' | 'icon' | '_id'>
  ): Observable<BEResponse<Tag>> {
    const { _id, ...body } = tag;
    return this.http.put<BEResponse<Tag>>(
      `${this.httpBaseUrl}/api/v2/model/${this.entityName}/${_id}`,
      body,
      { withCredentials: true }
    );
  }

  deleteTag(tag: Pick<Tag, '_id'>): Observable<BEResponse<Tag>> {
    return this.http.delete<BEResponse<Tag>>(
      `${this.httpBaseUrl}/api/v2/model/${this.entityName}/${tag._id}`,
      { withCredentials: true }
    );
  }
}
